import { Component, OnInit ,Input , Output, OnChanges, SimpleChanges} from '@angular/core';
import { MatSelectChange }  from '@angular/material';

@Component({
  selector: 'app-statutory-filter',
  templateUrl: './statutory-filter.component.html',
  styleUrls: ['./statutory-filter.component.scss']
})
export class StatutoryFilterComponent implements OnInit , OnChanges{

  @Input() subType: any;

  public years = [];

  public months= [];


  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['subType'] && this.subType){
        this.subType.selectedYear = !this.subType.selectedYear ? 'All' : this.subType.selectedYear;
        this.subType.selectedMonth =  !this.subType.selectedMonth ? 'All' :  this.subType.selectedMonth;
        this.initFilters();
    }
  }

  public initFilters(){
    this.reset();
    let yearMap = {
      'All':"All"
    };
    let monthMap = {
      'All':"All"
    };
    for(let topic of this.subType.topicsList){
        if(topic.year && topic.year!=="null" && topic.year!=="undefined"  && !yearMap[topic.year]){
          this.years.push(topic.year);
          yearMap[topic.year]=topic.year;
        }

        if(topic.month && topic.month!=="null" && topic.month!=="undefined" &&  !monthMap[topic.month] ){
          this.months.push(topic.month);
          monthMap[topic.month]=topic.month;
        }
    }
  }

  public onYearChange(event: MatSelectChange){
    this.subType.selectedYear = event.value;
  }

  public onMonthChange(event: MatSelectChange){
    this.subType.selectedMonth = event.value;
  }

  public reset(){
    this.years = ['All'];
    this.months = ['All'];
  }

}
